import { render, staticRenderFns } from "./SupervisorAdd.vue?vue&type=template&id=6eb2dd1a&scoped=true"
import script from "./SupervisorAdd.vue?vue&type=script&lang=js"
export * from "./SupervisorAdd.vue?vue&type=script&lang=js"
import style0 from "./SupervisorAdd.vue?vue&type=style&index=0&id=6eb2dd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2dd1a",
  null
  
)

export default component.exports